<template>
  <div :class="{ 'show--cookies' : !isCookiesAccepted }">

    <Head/>

    <AdminBar v-if="$page.props.current_admin"/>

    <EmployeurHeader />

    <AppNotifs />

    <AppAlerts />

    <main :class="profil" ref="Main">
      <slot></slot>
    </main>

    <AppFooter />

    <ContactModal v-model="Modales.contact" name="modalContact" />
    <SimulateurIFCModal v-model="Modales.simulateur_ifc" name="modalSimulateurIfc" />

    <Overlay />

    <GoogleAnalytics/>

  </div>
</template>

<script>
  import { nextTick } from 'vue'
  import { gsap } from 'gsap'
  import { Inertia } from '@inertiajs/inertia'
  import { isFirstLoad } from '@/store'
  import { isCookiesAccepted } from '@/store/cookies'
  import { Modales } from '@/store/modales'
  import AdminBar from "@components/admin/AdminBar"
  import EmployeurHeader from "@components/app/employeur/EmployeurHeader";
  import AppFooter from "@components/app/AppFooter";
  import AppNotifs from "@components/app/AppNotifs";
  import AppAlerts from "@components/app/AppAlerts";
  import Overlay from "@components/Overlay";
  import PageTransition from "@components/app/PageTransition";
  import ContactModal from "@components/contact/ContactModal";
  import Head from "@components/Head";
  import GoogleAnalytics from "@components/GoogleAnalytics";
  import SimulateurIFCModal from "@components/simulateur-ifc/SimulateurIFCModal";


  export default {
    components: {
      SimulateurIFCModal,
      GoogleAnalytics,
      AdminBar,
      EmployeurHeader,
      AppFooter,
      AppNotifs,
      AppAlerts,
      PageTransition,
      Overlay,
      ContactModal,
      Head
    },
    props: ['profil'],
    data() {
      return {
        isCookiesAccepted,
        Modales
      }
    },
    mounted() {

      isFirstLoad.value = false
      this.previousComponent = Inertia.page.component
      this.layoutEnterInteria = Inertia.on('navigate', this.onEnter)
      nextTick(() => this.onEnter())

    },
    unmounted() {
      this.layoutEnterInteria()
    },
    methods: {
      onEnter(e) {

        if (e){
          if (this.previousComponent === e.detail.page.component){
            this.previousComponent = e.detail.page.component;
            return;
          }
          this.previousComponent = e.detail.page.component;
        }

        const pageIn = gsap.timeline({
           paused: true,
           defaults: {
             duration: 1.2,
             ease: 'power3.out',
             clearProps: 'opacity',
             delay: 0.2
           }
         })
        const fadeEl = this.$refs.Main.querySelector(':scope > *');

        if (fadeEl && !fadeEl.classList?.contains('no--fade')){
          pageIn.from(this.$refs.Main.querySelector(':scope > *'), { opacity: 0 });
          pageIn.play();
        }

      }
    }
  }
</script>
